import * as enquiry from './enquiry';
import * as layout from './layout';
import * as support from './support';
import * as emails from './emails';
import * as ads from './ads';

const AppConst = {
  ads,
  enquiry,
  layout,
  support,
  emails
};

export { ads, enquiry, layout, support, emails };

export default AppConst;
